<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :before-close="handleClose"
    width="1200px"
    custom-class="peopleDialog">
    <div class="title" slot="title">
      {{id ? '编辑监管信息' : '添加监管信息'}}
    </div>
  <div class="form-content">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-position="top" class="ruleFormYan">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="检查时间" ref="do_date" prop="do_date">
            <div class="flex justify-start align-center">
              <el-date-picker
                class="inp"
                v-model="ruleForm.do_date"
                type="date"
                placeholder="选择日期"
                format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd">
              </el-date-picker>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="检查人员" ref="jiancha_name" prop="jiancha_name">
            <div class="flex justify-start align-center">
              <el-input v-model="ruleForm.jiancha_name" class="inp"></el-input>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <div class="title-flex">
            <b>机构公示情况</b>
          </div>
        </el-col>
        <el-col :span="12" >
          <el-form-item label="资金存管账户是否公示" ref="zijin_cunguan_is_gs" prop="zijin_cunguan_is_gs">
            <div class="flex justify-start align-center">
              <el-select v-model="ruleForm.zijin_cunguan_is_gs" placeholder="请选择" class="inp">
                <el-option
                  v-for="item in isYes"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12" >
          <el-form-item label="合同范本是否公示" ref="hetong_is_gs" prop="hetong_is_gs">
            <div class="flex justify-start align-center">
              <el-select v-model="ruleForm.hetong_is_gs" placeholder="请选择" class="inp">
                <el-option
                  v-for="item in isYes"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12" >
          <el-form-item label="课程单价是否公示" ref="price_is_gs" prop="price_is_gs">
            <div class="flex justify-start align-center">
              <el-select v-model="ruleForm.price_is_gs" placeholder="请选择" class="inp">
                <el-option
                  v-for="item in isYes"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12" >
          <el-form-item label="营业执照是否公示" ref="zhizhao_is_gs" prop="zhizhao_is_gs">
            <div class="flex justify-start align-center">
              <el-select v-model="ruleForm.zhizhao_is_gs" placeholder="请选择" class="inp">
                <el-option
                  v-for="item in isYes"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12" >
          <el-form-item label="投诉举报电话是否公示" ref="jubaophone_is_gs" prop="jubaophone_is_gs">
            <div class="flex justify-start align-center">
              <el-select v-model="ruleForm.jubaophone_is_gs" placeholder="请选择" class="inp">
                <el-option
                  v-for="item in isYes"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12" >
          <el-form-item label="教师情况是否公示" ref="teachers_is_gs" prop="teachers_is_gs">
            <div class="flex justify-start align-center">
              <el-select v-model="ruleForm.teachers_is_gs" placeholder="请选择" class="inp">
                <el-option
                  v-for="item in isYes"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12" >
          <el-form-item label="退费办法及流程是否公示" ref="tuifei_is_gs" prop="tuifei_is_gs">
            <div class="flex justify-start align-center">
              <el-select v-model="ruleForm.tuifei_is_gs" placeholder="请选择" class="inp">
                <el-option
                  v-for="item in isYes"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <div class="title-flex">
            <b>消防安全情况</b>
          </div>
        </el-col>
        <el-col :span="12" >
          <el-form-item label="安全管理是否合规（黄，橙）" ref="anquan_is_hegui" prop="anquan_is_hegui">
            <div class="flex justify-start align-center">
              <el-select v-model="ruleForm.anquan_is_hegui" placeholder="请选择" class="inp">
                <el-option
                  v-for="item in isYes"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="ruleForm.anquan_is_hegui == 2">
          <el-form-item label="安全管理存在的问题" ref="anquan_wenti" prop="anquan_wenti">
            <div class="flex justify-start align-center">
              <el-input v-model="ruleForm.anquan_wenti" class="inp"></el-input>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="ruleForm.anquan_is_hegui == 2">
          <el-form-item label="安全管理存在的问题是否整改" ref="anquan_is_zhenggai" prop="anquan_is_zhenggai">
            <div class="flex justify-start align-center">
              <el-select v-model="ruleForm.anquan_is_zhenggai" placeholder="请选择" class="inp">
                <el-option
                  v-for="item in isYes"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12" >
          <el-form-item label="是否存在重大事故隐患（红）" ref="yinhuan_is_exist" prop="yinhuan_is_exist">
            <div class="flex justify-start align-center">
              <el-select v-model="ruleForm.yinhuan_is_exist" placeholder="请选择" class="inp">
                <el-option
                  v-for="item in isYes"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="ruleForm.yinhuan_is_exist == 1">
          <el-form-item label="重大事故隐患分类" ref="yinhuan" prop="yinhuan">
            <div class="flex justify-start align-center">
              <el-select v-model="ruleForm.yinhuan" multiple placeholder="请选择" class="inp">
                <el-option
                  v-for="item in yinHuanOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="ruleForm.yinhuan_is_exist == 1">
          <el-form-item label="重大事故隐患是否整改" ref="yinhuan_is_zhenggai" prop="yinhuan_is_zhenggai">
            <div class="flex justify-start align-center">
              <el-select v-model="ruleForm.yinhuan_is_zhenggai" placeholder="请选择" class="inp">
                <el-option
                  v-for="item in isYes"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12" >
          <el-form-item label="近一年是否发生安全事故（红）" ref="shigu_is_exist" prop="shigu_is_exist">
            <div class="flex justify-start align-center">
              <el-select v-model="ruleForm.shigu_is_exist" placeholder="请选择" class="inp">
                <el-option
                  v-for="item in isYes"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="ruleForm.shigu_is_exist == 1">
          <el-form-item label="安全存在的问题" ref="shigu" prop="shigu">
            <div class="flex justify-start align-center">
              <el-input v-model="ruleForm.shigu" class="inp"></el-input>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12" >
          <el-form-item label="消防安全风险等级" ref="xiaofang_dengji" prop="xiaofang_dengji">
            <div class="flex justify-start align-center">
              <el-select v-model="ruleForm.xiaofang_dengji" placeholder="请选择" class="inp">
                <el-option
                  v-for="item in xiaofangLevelOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12" >
          <el-form-item label="其他问题情况" ref="other" prop="other">
            <div class="flex justify-start align-center">
              <el-input v-model="ruleForm.other" class="inp"></el-input>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <div class="title-flex">
            <b>整改情况</b>
          </div>
        </el-col>
        <el-col :span="12">
          <el-form-item label="整改情况" ref="is_zhenggai" prop="is_zhenggai">
            <div class="flex justify-start align-center">
              <el-select v-model="ruleForm.is_zhenggai" placeholder="请选择" class="inp">
                <el-option
                  v-for="item in zhengGaiOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="ruleForm.is_zhenggai == 2">
          <el-form-item label="整改时间" ref="zhenggai_time" prop="zhenggai_time">
            <div class="flex justify-start align-center">
              <el-date-picker
                class="inp"
                v-model="ruleForm.zhenggai_time"
                type="date"
                placeholder="选择日期"
                format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd">
              </el-date-picker>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="ruleForm.is_zhenggai == 2">
          <el-form-item label="整改内容" ref="zhenggai_content" prop="zhenggai_content">
            <div class="flex justify-start align-center">
              <el-input v-model="ruleForm.zhenggai_content" class="inp"></el-input>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="ruleForm.is_zhenggai == 2">
          <el-form-item label="整改通知书" class="" ref="zhenggai_file"
                        prop="zhenggai_file">
            <div class="flex justify-start align-center">
              <a :href="ruleForm.zhenggai_file"
                 v-if="ruleForm.zhenggai_file"
                 target="_blank" class="look">查看整改通知书</a>
              <upload-file
                name="zhenggai_file"
                @uploadFile="uploadFile"
              >
                <div class="btnUp" slot="upload">
                  <i class="iconfont icon-iconfontzhizuobiaozhun0263"></i> 上传整改通知书
                </div>
              </upload-file>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="ruleForm.is_zhenggai == 2">
          <div class="flex justify-start align-center">
            <div class="flex-sub flex-sub-w0">
              <el-form-item label="整改进度" ref="is_wancheng_zhenggai" prop="is_wancheng_zhenggai">
                <div class="flex justify-start align-center">
                  <el-select v-model="ruleForm.is_wancheng_zhenggai" placeholder="请选择" class="inp">
                    <el-option
                      v-for="item in GaiWanOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
              </el-form-item>
            </div>
            <el-form-item label="" v-if="ruleForm.is_wancheng_zhenggai == 2" class="errorTips"
                          ref="zhenggai_qing_file" prop="zhenggai_qing_file">
              <div class="flex justify-start align-center">
                <a :href="ruleForm.zhenggai_qing_file"
                   v-if="ruleForm.zhenggai_qing_file"
                   target="_blank" class="look mt15">查看附件</a>
                <upload-file
                  class="upZuj"
                  name="zhenggai_qing_file"
                  @uploadFile="uploadFile"
                >
                  <div class="btnUp" slot="upload">
                    <i class="iconfont icon-iconfontzhizuobiaozhun0263"></i> 上传附件
                  </div>
                </upload-file>
              </div>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <div class="title-flex">
            <b>约谈情况</b>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="flex justify-start align-center">
            <div class="flex-sub flex-sub-w0">
              <el-form-item label="约谈情况" ref="is_yuetan" prop="is_yuetan">
                <div class="flex justify-start align-center">
                  <el-select v-model="ruleForm.is_yuetan" placeholder="请选择" class="inp">
                    <el-option
                      v-for="item in yueTanOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
              </el-form-item>
            </div>
          </div>
        </el-col>
        <el-col :span="12" v-if="ruleForm.is_yuetan == 2">
          <el-form-item label="约谈时间" ref="yuetan_time" prop="yuetan_time">
            <div class="flex justify-start align-center">
              <el-date-picker
                class="inp"
                v-model="ruleForm.yuetan_time"
                type="date"
                placeholder="选择日期"
                format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd">
              </el-date-picker>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="ruleForm.is_yuetan == 2">
          <el-form-item label="被约谈人" ref="yuetan_ren" prop="yuetan_ren">
            <div class="flex justify-start align-center">
              <el-input v-model="ruleForm.yuetan_ren" class="inp"></el-input>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="ruleForm.is_yuetan == 2">
          <el-form-item label="约谈内容" ref="yuetan_content" prop="yuetan_content">
            <div class="flex justify-start align-center">
              <el-input v-model="ruleForm.yuetan_content" class="inp"></el-input>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="ruleForm.is_yuetan == 2">
          <el-form-item label="约谈纪要" class="errorTips" ref="yuetan_file"
                        prop="yuetan_file">
            <div class="flex justify-start align-center">
              <a :href="ruleForm.yuetan_file"
                 v-if="ruleForm.yuetan_file"
                 target="_blank" class="look">查看约谈纪要</a>
              <upload-file
                name="yuetan_file"
                @uploadFile="uploadFile"
              >
                <div class="btnUp" slot="upload">
                  <i class="iconfont icon-iconfontzhizuobiaozhun0263"></i> 上传约谈纪要
                </div>
              </upload-file>
            </div>
          </el-form-item>
        </el-col>
        <div v-for="(item,index) in ruleForm.tsList" :key="item.id">
        <el-col :span="24">
          <div class="title-flex">
            <b>投诉情况</b>
            <img src="@/assets/images/tianjiaicon.png" v-if="index == 0" class="add" @click="add()" alt="">
            <img src="@/assets/images/jianhaoicon.png" v-else class="add" @click="del(index)" alt="">
          </div>
        </el-col>
        <el-col :span="12">
          <el-form-item label="投诉时间"
                        :ref="'tsList.' + index + '.tousu_date'"
                        :prop="'tsList.' + index + '.tousu_date'"
                        :rules="{
                              required: false, message: '请选择', trigger: 'change'
                            }">
            <div class="flex justify-start align-center">
              <el-date-picker
                class="inp"
                v-model="item.tousu_date"
                type="date"
                placeholder="选择日期"
                format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd">
              </el-date-picker>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <div class="flex justify-start align-center">
            <div class="flex-sub flex-sub-w0">
              <el-form-item label="投诉渠道"
                            :ref="'tsList.' + index + '.tousu_qudao'"
                            :prop="'tsList.' + index + '.tousu_qudao'"
                            :rules="{
                              required: false, message: '请选择', trigger: 'change'
                            }">
                <div class="flex justify-start align-center">
                  <el-select v-model="item.tousu_qudao" placeholder="请选择" class="inp">
                    <el-option
                      v-for="item in tousuTypeOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
              </el-form-item>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="flex justify-start align-center">
            <div class="flex-sub flex-sub-w0">
              <el-form-item label="投诉内容"
                            :ref="'tsList.' + index + '.tousu_con'"
                            :prop="'tsList.' + index + '.tousu_con'"
                            :rules="{
                              required: false, message: '请选择', trigger: 'change'
                            }">
                <div class="flex justify-start align-center">
                  <el-select v-model="item.tousu_con" placeholder="请选择" class="inp">
                    <el-option
                      v-for="item in tousuContentOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
              </el-form-item>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <el-form-item label="投诉是否响应"
                        :ref="'tsList.' + index + '.tousu_is_xiangying'"
                        :prop="'tsList.' + index + '.tousu_is_xiangying'"
                        :rules="{
                              required: false, message: '请选择', trigger: 'change'
                            }">
            <div class="flex justify-start align-center">
              <el-select v-model="item.tousu_is_xiangying" placeholder="请选择" class="inp">
                <el-option
                  v-for="item in isYes"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="投诉是否解决"
                        :ref="'tsList.' + index + '.is_jiejue'"
                        :prop="'tsList.' + index + '.is_jiejue'"
                        :rules="{
                              required: false, message: '请选择', trigger: 'change'
                            }">
            <div class="flex justify-start align-center">
              <el-select v-model="item.is_jiejue" placeholder="请选择" class="inp">
                <el-option
                  v-for="item in isYes"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="item.is_jiejue == 1">
          <el-form-item label="投诉是否及时处理"
                        :ref="'tsList.' + index + '.is_jishi'"
                        :prop="'tsList.' + index + '.is_jishi'"
                        :rules="{
                              required: false, message: '请选择', trigger: 'change'
                            }">
            <div class="flex justify-start align-center">
              <el-select v-model="item.is_jishi" placeholder="请选择" class="inp">
                <el-option
                  v-for="item in isYes"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-form-item>
        </el-col>
        </div>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12" >
          <el-form-item label="上一年度累计投诉量" ref="leiji_tousu_year" prop="leiji_tousu_year">
            <div class="flex justify-start align-center">
              <el-input v-model="ruleForm.leiji_tousu_year" class="inp">
                <template slot="append">件</template>
              </el-input>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12" >
          <el-form-item label="评价周期累计投诉量" ref="leiji_tousu_month" prop="leiji_tousu_month">
            <div class="flex justify-start align-center">
              <el-input v-model="ruleForm.leiji_tousu_month" class="inp">
                <template slot="append">件（月）</template>
              </el-input>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12" >
          <el-form-item label="累计未处理投诉件数" ref="leiji_tousu_wei" prop="leiji_tousu_wei">
            <div class="flex justify-start align-center">
              <el-input v-model="ruleForm.leiji_tousu_wei" class="inp">
                <template slot="append">件</template>
              </el-input>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12" >
          <el-form-item label="是否存在信息变更" ref="is_biangeng" prop="is_biangeng">
            <div class="flex justify-start align-center">
              <el-select v-model="ruleForm.is_biangeng" placeholder="请选择" class="inp">
                <el-option
                  v-for="item in isYes"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="ruleForm.is_biangeng == 1">
          <el-form-item label="信息变更类型" ref="biangeng_con" prop="biangeng_con">
            <div class="flex justify-start align-center">
              <el-select v-model="ruleForm.biangeng_con" multiple placeholder="请选择" class="inp">
                <el-option
                  v-for="item in biangengTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12"  v-if="ruleForm.is_biangeng == 1">
          <el-form-item label="是否按要求进行变更备案" ref="is_baingeng_beian" prop="is_baingeng_beian">
            <div class="flex justify-start align-center">
              <el-select v-model="ruleForm.is_baingeng_beian" placeholder="请选择" class="inp">
                <el-option
                  v-for="item in isYes"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="ruleForm.is_baingeng_beian == 2">
          <el-form-item label="未进行变更备案原因" ref="weibeian" prop="weibeian">
            <div class="flex justify-start align-center">
              <el-select v-model="ruleForm.weibeian" placeholder="请选择" class="inp">
                <el-option
                  v-for="item in weibeianTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="btn-box">
      <div class="btn" @click="submitForm('ruleForm')">保存</div>
    </div>
  </div>
  </el-dialog>
</template>
<script>
import UploadFile from "@/components/UploadFile";
import {
  biangengTypeOptions, GaiWanOptions,
  isYes, tousuContentOptions, tousuTypeOptions, weibeianTypeOptions, xiaofangLevelOptions,
  yinHuanOptions, yueTanOptions, zhengGaiOptions,
} from "@/utils/const";
import {scrollIntoView} from "@/utils/utils";
import {get_jian, save_jian} from "@/api";
export default {
  name: "supervisionDialog",
  data() {
    return {
      isYes: isYes,
      yinHuanOptions: yinHuanOptions,
      xiaofangLevelOptions: xiaofangLevelOptions,
      zhengGaiOptions: zhengGaiOptions,
      yueTanOptions: yueTanOptions,
      tousuTypeOptions: tousuTypeOptions,
      tousuContentOptions: tousuContentOptions,
      weibeianTypeOptions: weibeianTypeOptions,
      biangengTypeOptions: biangengTypeOptions,
      GaiWanOptions:GaiWanOptions,
      ruleForm: {
        do_date: '', // 检查时间
        jiancha_name: '', // 检查时间
        zijin_cunguan_is_gs: '', // 资金存管账户是否公示
        hetong_is_gs: '', // 合同范本是否公示
        price_is_gs: '', // 课程单价是否公示
        zhizhao_is_gs: '', // 营业执照是否公示
        jubaophone_is_gs: '', // 投诉举报电话是否公示
        teachers_is_gs: '', // 教师情况是否公示
        tuifei_is_gs: '', // 退费办法及流程是否公示
        anquan_is_hegui: '', // 安全管理是否合规
        anquan_wenti: '', // 安全管理存在的问题
        anquan_is_zhenggai: '', // 安全管理存在的问题是否整改
        yinhuan_is_exist: '', // 是否存在重大事故隐患
        yinhuan: [], // 重大事故隐患分类
        yinhuan_is_zhenggai: '', // 重大事故隐患是否整改
        shigu_is_exist: '', // 近一年是否发生安全事故
        shigu: '', // 安全存在的问题
        xiaofang_dengji: '', // 消防安全风险等级
        other: '', // 其他问题情况
        is_zhenggai: '', // 整改情况
        zhenggai_time: '', // 整改时间
        zhenggai_content: '', // 整改内容
        zhenggai_file: '', // 整改内容
        is_wancheng_zhenggai: '', // 整改进度
        zhenggai_qing_file: '', // 完成整改附件
        is_yuetan: '', // 约谈情况
        yuetan_time: '', // 约谈情况
        yuetan_ren: '', // 被约谈人
        yuetan_content: '', // 约谈内容
        yuetan_file: '', // 约谈纪要附件
        leiji_tousu_year: '', // 上一年度累计投诉量
        leiji_tousu_month: '', // 评价周期累计投诉量
        leiji_tousu_wei: '', // 累计未处理投诉件数
        is_biangeng: '',    // 是否存在信息变更
        biangeng_con: [],    // 信息变更类型
        is_baingeng_beian: '',    // 是否按要求进行变更备案
        weibeian: '',    // 未进行变更备案原因
        tsList:[{
          tousu_date:'',
          tousu_qudao:'',
          tousu_con: '',
          tousu_is_xiangying: '',
          is_jiejue: '',
          is_jishi: '',
          id: Date.now()
        }]
      },
      rules: {
        leiji_tousu_wei: [
          {required: false, message: '请输入', trigger: 'blur'}
        ],
        leiji_tousu_month: [
          {required: false, message: '请输入', trigger: 'blur'}
        ],
        leiji_tousu_year: [
          {required: false, message: '请输入', trigger: 'blur'}
        ],
        weibeian: [
          {required: false, message: '请选择', trigger: 'change'}
        ],
        is_baingeng_beian: [
          {required: false, message: '请选择', trigger: 'change'}
        ],
        biangeng_con: [
          {required: false, message: '请选择', trigger: 'change'}
        ],
        is_biangeng: [
          {required: false, message: '请选择', trigger: 'change'}
        ],
        yuetan_content: [
          {required: false, message: '请输入', trigger: 'blur'}
        ],
        yuetan_ren: [
          {required: false, message: '请输入', trigger: 'blur'}
        ],
        zhenggai_content: [
          {required: false, message: '请输入', trigger: 'blur'}
        ],
        other: [
          {required: false, message: '请输入', trigger: 'blur'}
        ],
        jiancha_name: [
          {required: false, message: '请输入', trigger: 'blur'}
        ],
        shigu: [
          {required: false, message: '请输入', trigger: 'blur'}
        ],
        anquan_wenti: [
          {required: false, message: '请输入', trigger: 'blur'}
        ],
        yinhuan_is_zhenggai: [
          {required: false, message: '请输入', trigger: 'blur'}
        ],
        yuetan_file: [
          {required: false, message: '请上传', trigger: 'change'}
        ],
        zhenggai_file: [
          {required: false, message: '请上传', trigger: 'change'}
        ],
        zhenggai_qing_file: [
          {required: false, message: '请上传', trigger: 'change'}
        ],
        yuetan_time: [
          {required: false, message: '请选择', trigger: 'change'}
        ],
        is_yuetan: [
          {required: false, message: '请选择', trigger: 'change'}
        ],
        zhenggai_time: [
          {required: false, message: '请选择', trigger: 'change'}
        ],
        is_wancheng_zhenggai: [
          {required: false, message: '请选择', trigger: 'change'}
        ],
        is_zhenggai: [
          {required: false, message: '请选择', trigger: 'change'}
        ],
        xiaofang_dengji: [
          {required: false, message: '请选择', trigger: 'change'}
        ],
        shigu_is_exist: [
          {required: false, message: '请选择', trigger: 'change'}
        ],
        yinhuan: [
          {required: false, message: '请选择', trigger: 'change'}
        ],
        yinhuan_is_exist: [
          {required: false, message: '请选择', trigger: 'change'}
        ],
        anquan_is_zhenggai: [
          {required: false, message: '请选择', trigger: 'change'}
        ],
        anquan_is_hegui: [
          {required: false, message: '请选择', trigger: 'change'}
        ],
        tuifei_is_gs: [
          {required: false, message: '请选择', trigger: 'change'}
        ],
        teachers_is_gs: [
          {required: false, message: '请选择', trigger: 'change'}
        ],
        jubaophone_is_gs: [
          {required: false, message: '请选择', trigger: 'change'}
        ],
        zhizhao_is_gs: [
          {required: false, message: '请选择', trigger: 'change'}
        ],
        price_is_gs: [
          {required: false, message: '请选择', trigger: 'change'}
        ],
        hetong_is_gs: [
          {required: false, message: '请选择', trigger: 'change'}
        ],
        zijin_cunguan_is_gs: [
          {required: false, message: '请选择', trigger: 'change'}
        ],
        do_date: [
          {required: false, message: '请选择', trigger: 'change'}
        ],
      }
    }
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    id: {
      type: [String, Number],
      default: ''
    },
  },
  components: {UploadFile},
  created() {

  },
  methods: {
    async init(){
      let _data = await get_jian(this.id);
      if(_data.status == 200){
        this.ruleForm = {
          do_date: _data.data.do_date, // 检查时间
          jiancha_name: _data.data.jiancha_name, // 检查时间
          zijin_cunguan_is_gs: _data.data.zijin_cunguan_is_gs, // 资金存管账户是否公示
          hetong_is_gs: _data.data.hetong_is_gs, // 合同范本是否公示
          price_is_gs: _data.data.price_is_gs, // 课程单价是否公示
          zhizhao_is_gs: _data.data.zhizhao_is_gs, // 营业执照是否公示
          jubaophone_is_gs: _data.data.jubaophone_is_gs, // 投诉举报电话是否公示
          teachers_is_gs: _data.data.teachers_is_gs, // 教师情况是否公示
          tuifei_is_gs: _data.data.tuifei_is_gs, // 退费办法及流程是否公示
          anquan_is_hegui: _data.data.anquan_is_hegui, // 安全管理是否合规
          anquan_wenti: _data.data.anquan_wenti, // 安全管理存在的问题
          anquan_is_zhenggai: _data.data.anquan_is_zhenggai, // 安全管理存在的问题是否整改
          yinhuan_is_exist: _data.data.yinhuan_is_exist, // 是否存在重大事故隐患
          yinhuan: _data.data.yinhuan ? _data.data.yinhuan.split(',').map(Number) : [], // 重大事故隐患分类
          yinhuan_is_zhenggai: _data.data.yinhuan_is_zhenggai, // 重大事故隐患是否整改
          shigu_is_exist: _data.data.shigu_is_exist, // 近一年是否发生安全事故
          shigu: _data.data.shigu, // 安全存在的问题
          xiaofang_dengji: _data.data.xiaofang_dengji, // 消防安全风险等级
          other: _data.data.other, // 其他问题情况
          is_zhenggai: _data.data.is_zhenggai, // 整改情况
          zhenggai_time: _data.data.zhenggai_time, // 整改时间
          zhenggai_content: _data.data.zhenggai_content, // 整改内容
          zhenggai_file: _data.data.zhenggai_file, // 整改内容
          is_wancheng_zhenggai: _data.data.is_wancheng_zhenggai, // 整改进度
          zhenggai_qing_file: _data.data.zhenggai_qing_file, // 完成整改附件
          is_yuetan: _data.data.is_yuetan, // 约谈情况
          yuetan_time: _data.data.yuetan_time, // 约谈情况
          yuetan_ren: _data.data.yuetan_ren, // 被约谈人
          yuetan_content: _data.data.yuetan_content, // 约谈内容
          yuetan_file: _data.data.yuetan_file, // 约谈纪要附件
          leiji_tousu_year: _data.data.leiji_tousu_year, // 上一年度累计投诉量
          leiji_tousu_month: _data.data.leiji_tousu_month, // 评价周期累计投诉量
          leiji_tousu_wei: _data.data.leiji_tousu_wei, // 累计未处理投诉件数
          is_biangeng: _data.data.is_biangeng,    // 是否存在信息变更
          biangeng_con: _data.data.biangeng_con ? _data.data.biangeng_con.split(',').map(Number) : [],    // 信息变更类型
          is_baingeng_beian: _data.data.is_baingeng_beian,    // 是否按要求进行变更备案
          weibeian: _data.data.weibeian,    // 未进行变更备案原因
          tsList: _data.data.tsList.length ? _data.data.tsList : [{
            tousu_date:'',
            tousu_qudao:'',
            tousu_con: '',
            tousu_is_xiangying: '',
            is_jiejue: '',
            is_jishi: '',
            id: Date.now()
          }]
        }
      }
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid, validates) => {
        if (valid) {
          this.submitInfo()
        } else {
          scrollIntoView(this, validates)
        }
      });
    },

    async submitInfo() {
      let _data = await save_jian(
        this.id,
        this.ruleForm.do_date,
        this.ruleForm.jiancha_name,
        this.ruleForm.zijin_cunguan_is_gs,
        this.ruleForm.hetong_is_gs,
        this.ruleForm.price_is_gs,
        this.ruleForm.zhizhao_is_gs,
        this.ruleForm.jubaophone_is_gs,
        this.ruleForm.teachers_is_gs,
        this.ruleForm.tuifei_is_gs,
        this.ruleForm.anquan_is_hegui,
        this.ruleForm.anquan_wenti,
        this.ruleForm.anquan_is_zhenggai,
        this.ruleForm.yinhuan_is_exist,
        this.ruleForm.yinhuan.join(','),
        this.ruleForm.yinhuan_is_zhenggai,
        this.ruleForm.shigu_is_exist,
        this.ruleForm.shigu,
        this.ruleForm.xiaofang_dengji,
        this.ruleForm.other,
        this.ruleForm.is_zhenggai,
        this.ruleForm.zhenggai_time,
        this.ruleForm.zhenggai_content,
        this.ruleForm.zhenggai_file,
        this.ruleForm.is_wancheng_zhenggai,
        this.ruleForm.zhenggai_qing_file,
        this.ruleForm.is_yuetan,
        this.ruleForm.yuetan_time,
        this.ruleForm.yuetan_ren,
        this.ruleForm.yuetan_content,
        this.ruleForm.yuetan_file,
        this.ruleForm.leiji_tousu_year,
        this.ruleForm.leiji_tousu_month,
        this.ruleForm.leiji_tousu_wei,
        this.ruleForm.is_biangeng,
        this.ruleForm.biangeng_con.join(','),
        this.ruleForm.is_baingeng_beian,
        this.ruleForm.weibeian,
        JSON.stringify(this.ruleForm.tsList)
      );
      if(_data.status == 200) {
        this.$message.success(_data.msg);
        this.handleClose()
      } else {
        this.$message.error(_data.msg);
      }
    },

    handleClose(data = false){
      this.$refs.ruleForm.resetFields()
      this.$emit('handleClose',data)
    },

    uploadFile(data) {
      if(data.index === '') {
        this.ruleForm[data.name] = data.file.url
      }else {
        this.ruleForm[data.name][data.index].file = data.file.url
      }
    },

    add() {
      this.ruleForm.tsList.push({
        tousu_date:'',
        tousu_qudao:'',
        tousu_con: '',
        tousu_is_xiangying: '',
        is_jiejue: '',
        is_jishi: '',
        id: Date.now()
      })
    },

    del(index) {
      this.ruleForm.tsList.splice(index, 1)
    },
  },
  watch: {
    dialogVisible(){
      if(this.dialogVisible) {
        if(this.id) {
          this.init()
        }
      }
    }
  },
  filters: {}
}
</script>

<style scoped lang="scss">
.title {
  font-size: 18px;
  font-weight: bold;
  color: #333333;
}
.form-content {
  width: 100%;

  .title-flex {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-bottom: 20px;

    b {
      font-size: 18px;
      color: #000000;
      font-weight: bold;
      margin-right: 10px;
    }
  }


  .width {
    width: 400px;
  }

  .btn-box {
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 30px 0;

    .btn {
      width: 180px;
      height: 40px;
      background-image: linear-gradient(0deg,
        #2791ff 0%,
        #81b6ff 100%);
      border-radius: 20px;
      text-align: center;
      line-height: 40px;
      font-size: 16px;
      letter-spacing: 1px;
      color: #ffffff;
      cursor: pointer;
    }
  }

  .add {
    width: 24px;
    cursor: pointer;
  }


  .inp {
    flex: 1;
  }

  .tips {
    width: max-content;
    padding: 0 10px;
    height: 36px;
    background-color: #fef0ef;
    border-radius: 4px;
    margin-left: 10px;
    font-size: 14px;
    color: #f34336;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    line-height: 16px;

    i {
      font-size: 20px;
      color: #f34336;
      margin-right: 4px;
    }

    &.width {
      width: 160px;
    }
  }

  .look {
    width: max-content;
    padding: 0 10px;
    height: 36px;
    border: 1px solid #2791ff;
    color: #2791ff;
    line-height: 34px;
    text-align: center;
    font-size: 14px;
    margin-left: 10px;
    border-radius: 4px;

  }
  .mt15 {
    margin-top: 15px;
  }
  .btnUp {
    width: max-content;
    padding: 0 10px;
    height: 36px;
    margin-left: 10px;
    background-image: linear-gradient(90deg,
      #2791ff 0%,
      #81b6ff 100%);
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    color: #ffffff;

    i {
      font-size: 20px;
      color: #ffffff;
      margin-right: 5px;
      font-weight: 100;
    }
  }
}

.title-box {
  width: 100%;
  height: 60px;
  border-bottom: solid 2px #e3e7f0;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .tit-left {
    display: flex;
    justify-content: flex-start;
    padding-top: 25px;

    img {

    }

    b {
      font-size: 22px;
      color: #16181d;
      font-weight: bold;
      margin-left: 5px;
    }
  }
}
</style>


